import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MenuItem } from '@layouts/menu/menu.model';
import { NavigationEnd, Router } from '@angular/router';
import { MenuService } from '@layouts/menu/menu.service';
import { TicketManager } from '@routes/ticket-manager';
import { AuthService } from '@core/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';
import MetisMenu from 'metismenujs';
import Roles from '@shared/constants/roles';
import * as _ from 'lodash-es';
import System, { SYSTEM } from '@shared/constants/system';


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, AfterViewInit {
  @Input() selectedMenu;

  @ViewChild('sideMenu') sideMenu!: ElementRef;
  menu: any;
  menuItems: MenuItem[] = [];

  fontAwesomeType = 'fa-regular';

  @Output() menuClickEvent = new EventEmitter();

  constructor(private router: Router,
              private menuService: MenuService,
              private ticketManager: TicketManager,
              private authService: AuthService,
              private translate: TranslateService) {

    translate.setDefaultLang('en');
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
      }
    });
  }

  ngOnInit(): void {
    this.menuItems = this.menuService.getMenu();
  }

  /***
   * Activate dropdown set
   */
  ngAfterViewInit() {
    this.menu = new MetisMenu('#side-menu');
    // Refresh Component
    setTimeout(() => {
      const initMenu = this.menuItems.find(f => f.link === this.router.url);
      if (this.router.url === '/summary') {
        this.logoClick();
        return;
      }
      this.menuClick(initMenu);
    });
    this._activateMenuDropdown();
  }


  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className: any) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    const links: any = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    const paths = [];
    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }
    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('mm-active');
        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');
            if (childAnchor) {
              childAnchor.classList.add('mm-active');
            }
            if (childDropdown) {
              childDropdown.classList.add('mm-active');
            }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') {
                  childanchor.classList.add('mm-active');
                }
              }
            }
          }
        }
      }
    }
  }

  menuClick(item) {
    this.menuClickEvent.emit(item);
    this.menuService.selectedMenu$.next(item);
  }

  logoClick() {
    let item = {};
    const roles = this.authService.getRolesByCompany();
    const company = this.authService.getCurrentCompany();

    if (System.getSystem() !== SYSTEM.B2B) {
      if (!_.intersection(Roles.summaryView, roles).length) {
        this.router.navigate(['/concealed-damage']);
        return;
      }

      item = {
        componentId: 'summary',
        id: 0,
        label: 'SUMMARY',
        permits: [{ company, roles: ['DEALER'] }]
      };
    } else {
      if (_.intersection(Roles.b2bPartnerRsm, roles).length) {
        this.router.navigate(['/rsm-escalation']);
        return;
      } else {
        this.router.navigate(['/dashboards/ticket']);
        item = {
          componentId: 'dashboard-ticket',
          id: 0,
          label: 'Pending Dashboard',
          permits: [{ company, roles: Roles.b2bAdminOnly },]
        };
      }

    }

    this.menuClick(item);
  }

}
